<template>
  <span class="box box-link-pop text-center">
    <div class="box-body">
      <vc-donut
        background="#1f1f1f"
        class="progress-donut"
        :size="55"
        unit="%"
        :thickness="15"
        :sections="sections"
        >{{ progress }}%<br />PROGRESS</vc-donut
      >
    </div>
    <div class="box-body py-25 bg-light">
      <h3 class="font-weight-600 mt-0">Account Progress</h3>
    </div>
  </span>
</template>

<script>
export default {
  data() {
    return {
      progress: this.$store.getters.currentUser.account_progress,
      sections: [
        {
          value: this.$store.getters.currentUser.account_progress,
          color: "#f1b830",
        },
      ],
    };
  },
};
</script>
